module.exports = __webpack_public_path__ + "img/lydia.9a4fd0d6.jpg";